// src/utils/searchOptionLabel.ts
var getProductDescription = (option) => option?.params?.Description ?? option?.params?.description ?? "";
var getPartNumber = (option) => option?.params?.PartNumber ?? option?.params?.partNumber ?? "";
var getItemCode = (option) => option?.params?.ItemCode ?? option?.params?.itemCode ?? "";
var getImageUrl = (option) => option?.params?.ImageUrl ?? option?.params?.imageUrl ?? "";
var getSearchOptionLabel = (option) => {
  if (!option?.params) return "";
  const desc = getProductDescription(option);
  const code = getItemCode(option);
  const part = getPartNumber(option);
  return `${desc} (${part} - ${code})`.trim();
};

export {
  getProductDescription,
  getPartNumber,
  getItemCode,
  getImageUrl,
  getSearchOptionLabel
};
